import React from 'react';
import { BOTTOM_INDENTS, COLORS } from '@constants';
import { useStore } from '@hooks';
import { Icon, Typography } from '@ui';
import { Row } from 'antd';
import { observer } from 'mobx-react';
import { METHODS } from '../../constants';
import { StyledWrapper } from '../ProductsSyncProgress/styled';
import SyncBanner from '../SyncBanner';
import { StyledCol } from './styled';

const SyncFailed = observer(() => {
    const store = useStore();
    const { isManual, currentAccount } = store.accountsStore;

    const sourceName = currentAccount?.getSourceName;

    if (isManual) {
        return (
            <StyledWrapper>
                <SyncBanner method={METHODS.FAILED_PROGRESS} />
                <Typography.Text align='center' type='body2' color={COLORS.$gray60Black}>
                    <React.Fragment>
                        Klickly could not complete the sync with your {sourceName} account. This usually happens if the
                        connection token has expired or if Klickly no longer has permission to access your catalog.
                    </React.Fragment>
                </Typography.Text>
            </StyledWrapper>
        );
    }

    return (
        <React.Fragment>
            <StyledCol>
                <Row justify='center' style={BOTTOM_INDENTS.XXL}>
                    <Icon
                        roundedColor={COLORS.$white}
                        hoverRoundedColor={COLORS.$white}
                        roundedSize='120px'
                        size='40px'
                        color={COLORS.$gray60Black}
                        component={() => <Icon.SettingsIcon />}
                    />
                </Row>
                <Typography.Title level={2} color={COLORS.$gray60Black} style={BOTTOM_INDENTS.M}>
                    There was a failure with synchronizing your products
                </Typography.Title>
                <Typography.Text align='center' type='body2' color={COLORS.$gray60Black} style={BOTTOM_INDENTS.M}>
                    Please, contact support team in case this issue remains
                </Typography.Text>
            </StyledCol>
        </React.Fragment>
    );
});

export default SyncFailed;
